import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '火影同人指南',
    url: 'https://naruto-doujin.com',
    description: '深度解析火影同人文化的起源、创作风格与收藏价值，带你了解火影忍者周边同人圈的独特生态。',
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '火影同人指南',
    url: 'https://naruto-doujin.com',
    description: '火影粉丝与同人爱好者的专业参考资料平台',
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '火影同人创作完全指南 - 首页',
    description: '深度解析火影同人文化的起源、创作风格与收藏价值，带你了解火影忍者周边同人圈的独特生态。',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}